import { Link, Text } from "@certn/cascadia";
import {
  BasicButton,
  Container,
  Layout,
  MediaQuery,
  Stack,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { AppFooterLinks } from "../../components/app-footer/AppFooterLinks";
import { AppHeader } from "../../components/app-header/AppHeader";
import { AppNavigation } from "../../components/app-navigation/AppNavigation";
import { PageTitle } from "../../components/page-title/PageTitle";
import { MonitoringDashboardTable } from "./components/MonitoringDashboardTable";
import { useDashboardSummary } from "./useMonitoringApi";
import { useCanEnrollInMonitoring } from "./useCanEnrollInMonitoring";

const MONITORING_LEARN_MORE_URL =
  "https://help.certn.co/hc/en-us/articles/54138759910931-Continuous-Monitoring-in-CertnCentric";

export function MonitoringPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canEnroll = useCanEnrollInMonitoring();
  const { data: summary } = useDashboardSummary(canEnroll);
  const hasEligible = canEnroll && (summary?.eligible_count ?? 0) > 0;

  return (
    <Layout
      layout="narrow"
      header={<AppHeader />}
      navigation={<AppNavigation />}
      footer={<AppFooterLinks />}
    >
      <Container layout="full-width">
        <Stack gap="space-4">
          <PageTitle
            actions={
              canEnroll && (
                <BasicButton
                  isDisabled={!hasEligible}
                  onPress={() => navigate("/monitoring/enroll")}
                  testID="monitoring-enroll-applicants-button"
                >
                  {t("Enroll applicants")}
                </BasicButton>
              )
            }
          >
            {t("Monitoring")}
          </PageTitle>
          <MediaQuery sm type="hide">
            <Stack orientation="horizontal" gap="space-2">
              <Text color="text-weak">
                <Trans>
                  View and manage applicants enrolled in continuous monitoring.
                </Trans>
              </Text>
              <Link
                target="_blank"
                href={MONITORING_LEARN_MORE_URL}
                textStyle="global/body-secondary"
                linkStyle="monochrome"
                testID="monitoring-learn-more-link"
              >
                <Trans>Learn more</Trans>
              </Link>
            </Stack>
          </MediaQuery>

          <MonitoringDashboardTable />
        </Stack>
      </Container>
    </Layout>
  );
}
